<script setup lang="ts">
import { copyToClipboard } from '@/utils/apostatudo/clipboard';

const props = defineProps<{
  deposit: DefaultDepositInfoResponse;
}>();

const emit = defineEmits(['toggleModalInner']);

const { closeModal } = useLayoutStore();
const { updateWallet } = useWallet();

function closePaymentInfos() {
  emit('toggleModalInner');
}

const inputCodeElement = ref();

const isClabeCodeCopied = ref<boolean>(false);

const handdleCopyCode = async () => {
  const codeToCopy = String(props.deposit.barcode_number) || 'Fail';

  try {
    inputCodeElement.value?.select?.();
  } catch {}

  if (await copyToClipboard(codeToCopy)) {
    isClabeCodeCopied.value = true;
    setTimeout(() => (isClabeCodeCopied.value = false), 2000);
  }
};

const handdleOxxoPayed = () => {
  closeModal();
  updateWallet();
};

onUnmounted(() => {
  if (localStorage.getItem('start_countdown')) {
    localStorage.removeItem('start_countdown');
  }

  if (localStorage.getItem('init_countdown')) {
    localStorage.removeItem('init_countdown');
  }
});
</script>

<template>
  <div
    ref="deposit-payment"
    class="deposit-payment"
  >
    <button
      class="scan-title"
      @click="closePaymentInfos()"
    >
      &#8592; {{ $t('deposit.general.go_back') }}
    </button>

    <div class="text-center mt-3 mb-5">
      <h5 class="scan-title">
        {{ $t('deposit.oxxo.result_title') }}
      </h5>

      <div
        v-if="deposit.barcode"
        class="barCodeBox"
      >
        <img
          alt="Barcode"
          fluid
          :src="deposit.barcode"
        />
      </div>

      <div
        class="clickToCopy"
        @click="handdleCopyCode"
      >
        <div class="handIcon">
          <NuxtIcon name="hand_pointer" />
        </div>
        <div class="my-3">
          <p
            ref="input"
            class="depositValue"
          >
            {{ deposit.amount }}
          </p>
        </div>

        <div class="inputCode">
          <input
            ref="inputCodeElement"
            class="input-center small"
            readonly
            type="text"
            :value="deposit.barcode_number"
          />
          <button
            :class="['buttonsBottom', appNameLower()]"
            size="lg"
            variant="secondary"
          >
            <NuxtIcon
              v-if="isClabeCodeCopied"
              name="check"
            />
            {{
              isClabeCodeCopied
                ? $t('deposit.oxxo.code_copied')
                : $t('deposit.oxxo.copy_code_button')
            }}
          </button>
        </div>
      </div>

      <div class="timer mt-5 mb-0">
        <WidgetsCountdown
          class="text-xs"
          :progress-bar="true"
          :total-time="600"
        >
          <template #process="{ time }">
            <div class="timer_wrapper flex flex-row items-end justify-between">
              <span class="bonus-countdown-expire text-warning font-bold">
                {{ $t('deposit.oxxo.time_to_pay') }}
              </span>
              <span class="bonus-countdown-time text-texts font-bold text-sm">
                {{ `${time.minutes}:${time.seconds}` }}
              </span>
            </div>
          </template>
          <template #finish>
            <span class="bonus-countdown-expire text-error font-bold">
              {{ $t('deposit.oxxo.time_finished') }}
            </span>
          </template>
        </WidgetsCountdown>
      </div>

      <div class="mt-3">
        <button
          class="buttonsBottom small"
          variant="primary"
          @click="handdleOxxoPayed"
        >
          {{ $t('deposit.oxxo.confirm_payment') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.deposit-payment {
  .scan-title {
    @apply text-auth-texts m-1 mb-2 max-w-[280px] mx-auto;
  }

  .barCodeBox {
    @apply w-auto max-w-64 h-auto mx-auto bg-white rounded p-4;
  }

  .clickToCopy {
    @apply border-dashed border-auth-texts/60 border rounded-lg px-7 py-8 my-5 relative mx-1 md:mx-4;
    .handIcon {
      @apply absolute top-4 right-4 text-auth-texts/40 text-3xl cursor-pointer;
    }
    .depositValue {
      @apply text-primary font-bold text-3xl leading-3 -mt-1 mb-5;
    }
    .inputCode {
      @apply w-full flex gap-2;
      .input-center {
        @apply bg-auth-bg-inputs text-auth-text-inputs/80 text-center rounded-lg w-full px-4 h-[50px] text-base;
      }
    }
  }

  .timer {
    @apply px-3 pb-4 my-5 relative mx-1 md:mx-4;
  }

  .buttonsBottom {
    @apply inline-flex items-center justify-center gap-2 text-auth-button-bg bg-auth-button-bg/10 py-2 md:py-3 px-6 rounded w-full md:w-auto whitespace-nowrap text-sm;
    &.small {
      @apply text-sm py-2 px-5 mt-2 -mb-2 text-success bg-success/10 w-auto;
    }
  }
}
</style>
